import { useState } from 'react';
import { DatePicker, TimePicker } from '@repo/ui-web';

export function DatePickerShowcase() {
  const [date, setDate] = useState<Date | null>(new Date());
  const [time, setTime] = useState<Date | null>(new Date());
  const labels = { trigger: 'Pick a date' };

  return (
    <div className="space-y-4">
      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">Date</p>
        <DatePicker value={date} onChange={setDate} labels={labels} />
      </div>

      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">Time</p>
        <TimePicker value={time} onChange={setTime} label="Pick a time" />
      </div>
    </div>
  );
}
